import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';
import { NotificationType, NotificationChannel } from './useGetNotifications';

export type EnabledNotificationTypesDict = Partial<Record<NotificationType, NotificationChannel[]>>;

export interface UserInfo {
    _id: string;
    email: string;
    firstName: string;
    lastName: string;
    username?: string;
    admin: boolean;
    position: string;
    organizationId?: string;
    managementSystem?: 'ccc' | 'nex';
    myLocations?: Array<string> | 'all';
    enabledNotificationTypes?: EnabledNotificationTypesDict;
    notificationsEnabled: boolean;
    dailyEmailEnabled: boolean;
    presenceStatus?: 'available' | 'away';
    statusNote?: string;
    awayStartsAt?: string;
    awayEndsAt?: string;
    lastActive?: string;
}

const getProfile = async (sessionId: string): Promise<UserInfo> => {
    const { data } = await axios.post(`${API_URL}/profile`,
        {},
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
    return data;

};

export const useGetProfile = () => {
    const sessionContext = useContext(SessionContext);
    return useQuery({
        queryKey: ['profile'],
        queryFn: () => getProfile(sessionContext?.sessionId ?? '')
    });
};
